export const formatFiltersFactory = (options) => {
    const { isValueDateString, formatDate, entity, } = options;
    const formatFilters = (originalFilters) => {
        const formattedFilters = {};
        for (const filterKey of Object.keys(originalFilters)) {
            const filterValue = originalFilters[filterKey];
            if (filterKey === 'entity' && !filterValue) {
                formattedFilters[filterKey] = entity;
                continue;
            }
            if (filterValue === undefined || filterValue === '') {
                continue;
            }
            if (isValueDateString(filterValue)) {
                formattedFilters[filterKey] = formatDate(filterValue);
                continue;
            }
            formattedFilters[filterKey] = filterValue;
        }
        return formattedFilters;
    };
    return formatFilters;
};
//# sourceMappingURL=formatFilters.js.map